import { getPresetEntries } from "./schedule-presets.macro" with { type: "macro" };

export const schedulePresets = getPresetEntries();

export type SchedulePreset = (typeof schedulePresets)[number];
